<section class="about-banner">
    <div class="container">       
      <div class="row d-flex align-items-center justify-content-center">
        <div class="about-content col-lg-12 mt-5">
          <h1 class="text-white">
            Skills      
          </h1> 
          <p class="text-white link-nav"><a routerLink="/">Home </a>  <span class="lnr lnr-arrow-right"></span>
            <a routerLink="/my_skills"> Skills</a>
          </p>
          <h4 class="site-banner">
            Get to know me as a learner. You can find out about my skills and more below.
          </h4>
        </div>  
      </div>
    </div>
  </section>
  <section class="job-area offwhite pt-3 section-gap-bottom-90">
    <div class="container">
      <div style="margin-top: 20px;">
        <div class="text"></div>
        <div class="row" >
          <div class="col-md-6">
            <div class="section-title">
              <h1>Areas</h1>
              <div class="align-left">Full Stack Development, UI/UX Designing are among my strongest skills. I have created many solid frontend / Backend Application. Also i am giving some of my time to Cloud Technology and Deep Learning.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="section-title">
              <h1>Tools</h1>
            </div>
            <div class="align-left">
              <strong>OS&nbsp;&nbsp;&nbsp;</strong> Windows 10 ,Ubuntu 20.04<br>
              <br>  
              <strong>Code Edtior &nbsp;&nbsp;&nbsp; </strong>Sublime Text, Visual Studio Code<br><br>
              <strong>Other &nbsp;&nbsp;&nbsp;  </strong>Git, Photoshop, Git Bash<br><br>
              <strong>Gadgets  &nbsp;&nbsp;&nbsp; </strong>Dell Vostro 15 (1550) ,PC build.<br><br>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  